import React, { useEffect, useRef, useState } from "react";
import styles from "./StaffList.module.sass";
import cn from "classnames";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Filters from "../../components/Filters";
import { UseDisclosure } from "../../hooks/use-disclosure";
import Settings from "./Settings";
import Table from "./Table";
import Details from "./Details";
import { useHistory, useParams } from "react-router";
import { UseApi } from "../../hooks/use-api";
import { GetAdminUsers, GetUsers } from "../../Services/lib/admin";
import SendMailModal from "../ExploreCreators/Creator/sendMailModal";
import { GetBrand, GetBrandInviteList } from "../../Services/lib/brand";
import { useUser } from "../../context";
import InviteList from "./Invites";
import customers from "../../i11/Customers";
import CSVSettings from "./csv";
export const PageLimit = 12;

const StaffList = () => {
	const { type, id } = useParams();
	const history = useHistory();
	const [search, setSearch] = useState("");
	const [visible, setVisible] = useState(false);
	const [csv, setcsv] = useState(false);

	const {
		isOpen: isOpen_,
		onClose: onClose_,
		onOpen: onOpen_,
	} = UseDisclosure();
	const {
		locale,
		tokens: { group },
	} = useUser();
	const cnt = useRef(0);
	const {
		isOpen: isOpenSendMail,
		onOpen: onOpenSendMail,
		onClose: onCloseSendMail,
	} = UseDisclosure();
	const { isOpen, onOpen, onClose } = UseDisclosure(id ? true : false);
	const [detailData, setDetailData] = useState(id ? { _id: id } : undefined);
	const [filter, setFilter] = useState({
		offset: 0,
		limit: PageLimit,
		sortBy: "userName",
		orderBy: "asc",
		q: "",
		isAdmin: type === "staff" ? "YES" : "NO",
		isSuspended: true,
	});

	const close = () => {
		history.push(`/customers/list/${type}/`);
	};

	const [{ data: brand }, getBrand] = UseApi({
		service: GetBrand,
	});

	const [{ data: res, isLoading }, fetch] = UseApi({ service: GetUsers });
	const [{}, getInviteList] = UseApi({ service: GetBrandInviteList });

	const [invites, setInvites] = useState([]);

	const [{ data: admins, isLoading: adminIsLoading }, getAdmin] = UseApi({
		service: GetAdminUsers,
	});

	useEffect(() => {
		if (type === "admin") {
			getAdmin();
		} else {
			fetch(filter);
		}
	}, [filter]);

	const iniInvites = async () => {
		const res = await getInviteList();
		if (res) {
			const arr = [];
			res.forEach((e) => {
				e.invitedEmails.forEach((el) => {
					arr.push({
						from: e.creator?.userName,
						to: el.sentMail,
						status: el.status,
						role: el.userRole,
						createdAt: e.createdAt,
						_id: e._id + el.sentMail,
					});
				});
			});
			setInvites(arr);
			console.log(arr);
		}
	};

	useEffect(() => {
		if (type === "staff") {
			getBrand();
			iniInvites();
		}
		if (cnt.current > 0) {
			setFilter((p) => {
				return {
					...p,
					isAdmin: type === "staff" ? "YES" : "NO",
				};
			});
		}
		cnt.current += 1;
	}, [type]);

	const refreshUser = () => {
		if (type === "admin") {
			getAdmin();
		} else {
			fetch(filter);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		close();
		setFilter((p) => {
			return {
				...p,
				q: e.target[0].value,
			};
		});
	};

	useEffect(() => {
		if (!id) onClose();
	}, [id]);

	return (
		<>
			<Card
				className={cn(styles.card, { [styles.hidden]: isOpen })}
				title={customers[locale][type]}
				classTitle={cn("title-purple", styles.title)}
				classCardHead={cn(styles.head, { [styles.hidden]: isOpen })}
				head={
					type !== "admin" && (
						<>
							<Form
								className={styles.form}
								value={search}
								setValue={setSearch}
								onSubmit={handleSubmit}
								required={false}
								placeholder={customers[locale].search_holder}
								type="text"
								name="search"
								icon="search"
							/>
							{type === "staff" && group !== "brandOperator" && (
								<>
									<button className="button-small" onClick={onOpenSendMail}>
										{customers[locale].invite}
									</button>
									<div className={styles.btnTop}>
										{invites.length > 0 && <span>{invites.length}</span>}
										<button
											onClick={onOpen_}
											className={cn("button-small button-stroke")}
										>
											{customers[locale].invites}
										</button>
									</div>
								</>
							)}

							{res && type === "customer" && (
								<Filters
									className={styles.filters}
									title={customers[locale].down_csv}
									visible={csv}
									icon="download"
									setVisible={setcsv}
								>
									{csv && (
										<CSVSettings
											count={res.count || 1}
											close={() => setcsv(false)}
										/>
									)}
								</Filters>
							)}
							<Filters
								visible={visible}
								setVisible={setVisible}
								className={styles.filters}
								title={customers[locale].filter}
							>
								<Settings
									setVisible={setVisible}
									filter={filter}
									setFilter={setFilter}
								/>
							</Filters>
						</>
					)
				}
			>
				<div className={cn(styles.row, { [styles.flex]: isOpen })}>
					{!isOpen && (
						<Table
							res={type === "admin" ? { users: admins || [], count: 0 } : res}
							isLoading={isLoading || adminIsLoading}
							setFilter={setFilter}
							filter={filter}
							className={styles.table}
							activeTable={isOpen}
							onClose={onClose}
							onOpen={onOpen}
							setDetailData={setDetailData}
						/>
					)}
					{isOpen && (
						<Details
							refreshUser={refreshUser}
							data={detailData}
							className={styles.details}
							onClose={close}
						/>
					)}
				</div>
			</Card>
			<SendMailModal
				data={brand}
				visible={isOpenSendMail}
				onClose={onCloseSendMail}
			/>
			<InviteList invites={invites} isOpen={isOpen_} onClose={onClose_} />
		</>
	);
};

export default StaffList;
